import gql from 'graphql-tag';
import { PageInfoFragment } from '@app/pages/cmms/graphql/cmms-fragments';

export const ClassificationsQuery = gql`
	query ClassificationsQuery($name: String, $first: Int, $type: ClassificationTypes) {
		classificationsV2(name: $name, first: $first, typeFilter: $type) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				node {
					name
					pk
					type
					parentPk
				}
			}
			totalCount
		}
	}
	${PageInfoFragment}
`;
